import React from "react"

import RPMCriticalPatientScreen from "../components/RPMCriticalInitialScreen/RPMCriticalPatientScreen"

const RPMCriticalPatientInitialScreen = () => <RPMCriticalPatientScreen />

export default RPMCriticalPatientInitialScreen
